import { Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { SETTINGS_MULTI_ITEM } from "constants/sliderSetting";
import Slider from "react-slick";
import Zoomit from "assets/image/zoomit.png";
import Brat from "assets/image/brat-news.png";
import Sayar from "assets/image/sayar-new.png";
import Economy from "assets/image/economy.png";
import Titr from "assets/image/titr-online.png";
import Student from "assets/image/Student-new.png";
import Jsm from "assets/image/jsm.png";
import Pay from "assets/image/pay-way.png";
import Tabnak from "assets/image/tabnak.png";
import EconomyOnline from "assets/image/economy-online.png";
import "assets/styles/components/variantProperty.scss";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.css";

export default function Media() {
  const { t } = useTranslation();

  const settings = SETTINGS_MULTI_ITEM;

  const brandItems = [
    { brand: Zoomit },
    { brand: Brat },
    { brand: Sayar },
    { brand: Economy },
    { brand: Titr },
    { brand: Jsm },
    { brand: Pay },
    { brand: EconomyOnline },
    { brand: Student },
    { brand: Tabnak },
  ];

  return (
    <div className="overflow-hidden text-center">
      <Row>
        <Col
          xs="12"
          className="d-flex flex-column align-items-center justify-content-center pb-5"
        >
          <div className="d-flex flex-column justify-content-center align-items-center ">
            <span className="text-warning-light fw-medium pb-2">
              {t("Media")}
            </span>
            <span className="fs-5 text-primary-light fw-bold">
              {t("Coinnik market in media")}
            </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="py-4">
          <Slider {...settings}>
            {brandItems.map((item) => (
              <img
                className="style-all-brand-img"
                alt="image"
                src={item.brand}
              />
            ))}
          </Slider>
        </Col>
      </Row>
    </div>
  );
}
